import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
let baseURL = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API : '/prod-api'
window.baseURL = baseURL

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseURL,
  // 超时
  timeout: 50000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    
    if (code == 401) {
      MessageBox.confirm(
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
    } else if (code == 500) {
      Message({
        message: msg,
        type: 'error',
        duration: 3 * 1000
      })
      window.endLoading()
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Notification.error({
        title: msg
      })
      window.endLoading()
      return Promise.reject('error')
    } else {
      return res.data
    }
    window.endLoading()
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
      return
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
      return
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统正在升级，请稍等";
    }
    Message({
      message: message,
      type: 'error',
      duration: 3 * 1000
    })
    window.endLoading()
    return Promise.reject(error)
  }
)

export default service
